import { useEffect, useState } from 'react';
export var useNavHeight = function () {
    var _a = useState(0), height = _a[0], setHeight = _a[1];
    useEffect(function () {
        window.addEventListener('fromFlutter', function (event) {
            var height = event.detail.height;
            setHeight(Math.floor(height));
        });
        if (window.toFlutter) {
            window.toFlutter.postMessage(JSON.stringify({ method: 'getStatusBarHeight' }));
        }
    }, []);
    return height;
};
export var getInfo = function (key) {
    var _a = useState(null), info = _a[0], setInfo = _a[1];
    useEffect(function () {
        window.addEventListener('fromDanaFlutter', function (event) {
            // console.log(event)
            setInfo(event.detail);
        });
        if (window.toFlutter) {
            window.toFlutter.postMessage(JSON.stringify({ method: 'info' }));
        }
    }, []);
    return info ? info[key] : null;
};
